<section class="permissoes-shell">
  <header class="permissoes-hero">
    <div>
      <h2 class="permissoes-title">Permissões de Acesso</h2>
      <p class="permissoes-subtitle" *ngIf="usuario">
        Usuário: <strong>{{ usuario.nomeCompleto }}</strong> ({{ usuario.nomeUsuario }})
      </p>
    </div>
    <button class="btn btn-outline-secondary" (click)="voltar()">Voltar</button>
  </header>

  <div *ngIf="carregando" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Carregando...</span>
    </div>
  </div>

  <div *ngIf="!carregando">
    <div *ngIf="menuTree.length === 0" class="text-center text-muted py-4">
      Nenhum item de menu encontrado.
    </div>

    <div class="table-responsive">
      <table class="table table-bordered table-hover align-middle">
        <thead class="table-dark">
          <tr>
            <th scope="col" style="width: 50%">Tela / Menu</th>
            <th scope="col" class="text-center">Visualizar</th>
            <th scope="col" class="text-center">Editar</th>
            <th scope="col" class="text-center">Excluir</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let node of menuTree">
            <ng-container *ngTemplateOutlet="menuRow; context: { $implicit: node, nivel: 0 }"></ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</section>

<ng-template #menuRow let-node let-nivel="nivel">
  <tr [class.table-light]="node.children.length > 0">
    <td [style.padding-left.px]="16 + nivel * 24">
      <span *ngIf="node.children.length > 0" class="me-1">
        <i class="bi bi-folder text-warning"></i>
      </span>
      <span *ngIf="node.children.length === 0" class="me-1">
        <i class="bi bi-file-text text-secondary"></i>
      </span>
      <strong *ngIf="node.children.length > 0">{{ node.menuItem.title }}</strong>
      <span *ngIf="node.children.length === 0">{{ node.menuItem.title }}</span>
    </td>
    <td class="text-center">
      <div class="form-check d-flex justify-content-center">
        <input
          class="form-check-input"
          type="checkbox"
          [(ngModel)]="node.podeVisualizar"
          (change)="onVisualizarChange(node)"
          [disabled]="node.salvando"
        />
      </div>
    </td>
    <td class="text-center">
      <div class="form-check d-flex justify-content-center">
        <input
          class="form-check-input"
          type="checkbox"
          [(ngModel)]="node.podeEditar"
          (change)="onEditarChange(node)"
          [disabled]="node.salvando"
        />
      </div>
    </td>
    <td class="text-center">
      <div class="form-check d-flex justify-content-center">
        <input
          class="form-check-input"
          type="checkbox"
          [(ngModel)]="node.podeExcluir"
          (change)="onExcluirChange(node)"
          [disabled]="node.salvando"
        />
      </div>
    </td>
  </tr>
  <ng-container *ngFor="let child of node.children">
    <ng-container *ngTemplateOutlet="menuRow; context: { $implicit: child, nivel: nivel + 1 }"></ng-container>
  </ng-container>
</ng-template>
